// import { PayrollPensionableEarningsList } from "components/PayrollPensionableEarnings";
import { FC } from "react";

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { PayrollPensionableEarningList } from "../../components/PayrollPensionableEarningList/PayrollPensionableEarningList";

export interface IPayrollPensionableEarningsListPage {}

export const PayrollPensionableEarningsListPage: FC<
	IPayrollPensionableEarningsListPage
> = (props: IPayrollPensionableEarningsListPage) => {
	return (
		<AuthenticatedLayout
			pageTitle="Payroll Pensionable Earnings"
			pageTitleIcon={<DescriptionOutlinedIcon />}
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[]}
			mainContents={<PayrollPensionableEarningList />}
		/>
	);
};
